// Spotting an in-app browser: the web view Discord, Instagram, TikTok, Snapchat, Facebook,
// Messenger, X, the Google app, LINE or KakaoTalk opens a link in. Re:Vault needs a service
// worker, and most of these views have none, so the page would load and then do nothing.
// Pure (takes the user agent and what the browser can do), so the tests can feed it a table.

// Tokens these apps put in their user agent. "; wv)" is Android's System WebView.
const APP = /\b(?:Discord|Instagram|FBAN|FBAV|FB_IAB|FBIOS|Messenger|Snapchat|TikTok|BytedanceWebview|Twitter|GSA)\b|musical_ly|\bLine\/|KAKAOTALK|; wv\)/;
// A real browser. Its own private mode or an http page can lack a service worker too, and the
// banner would only be wrong there.
const REAL = /\b(?:CriOS|FxiOS|EdgiOS|OPiOS|EdgA|Edg|Firefox|OPR|SamsungBrowser)\/|\bChrome\/\d|\bVersion\/[\d.]+ (?:Mobile\/\w+ )?Safari\//;

// ua: navigator.userAgent. sw: whether navigator.serviceWorker exists.
export function inAppBrowser(ua, { sw = true } = {}) {
	ua = String(ua || "");
	if (/\bElectron\//.test(ua)) return false; // the Discord desktop app, which has a worker
	// Android web views (System WebView, and Instagram or Facebook on Android) can run a service
	// worker, so there an app token only counts when the worker is really missing. iOS app views
	// (WKWebView) never get one.
	if (APP.test(ua)) return /\bAndroid\b/.test(ua) ? !sw : true;
	if (REAL.test(ua)) return false;
	return !sw;
}

// Which full browser to send them to. iPadOS web views can report a Mac, so a Mac with a
// touchscreen counts as iOS.
export function inAppPlatform(ua, touch = 0) {
	ua = String(ua || "");
	if (/\b(?:iPhone|iPad|iPod)\b/.test(ua) || (/\bMacintosh\b/.test(ua) && touch > 1)) return "ios";
	if (/\bAndroid\b/.test(ua)) return "android";
	return "other";
}

export function inAppCopy(platform) {
	const lead = "Re:Vault needs a full browser to work. ";
	if (platform === "ios") return { text: lead + "Open this page in Safari.", how: "Tap ⋯ or the share icon, then Open in Safari." };
	if (platform === "android") return { text: lead + "Open this page in Chrome.", how: "Tap ⋮, then Open in Chrome." };
	return { text: lead + "Open this page in your browser.", how: "Use this app's menu to open the page in your browser." };
}
